/* NW Wellness — Product hero
   Variant matching: when a pill option changes, find the matching
   variant and update the hidden variant id, price, compare-at,
   availability, and stock dot. Thumbnail clicks swap the main image. */

(function () {
  class NWProductForm extends HTMLElement {
    connectedCallback() {
      const json = document.querySelector('[data-nw-product-json]');
      try {
        this.product = json ? JSON.parse(json.textContent) : null;
      } catch (e) { this.product = null; }
      if (!this.product) return;

      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-nw-variant-id]');
      this.priceEl = this.querySelector('[data-nw-price]');
      this.compareEl = this.querySelector('[data-nw-compare]');
      this.stockLabel = this.querySelector('[data-nw-stock-label]');
      this.stockDot = this.querySelector('[data-nw-stock-dot]');
      this.ctaLabel = this.querySelector('[data-nw-cta-label]');
      this.addBtn = this.querySelector('[data-nw-add]');
      this.soldoutNote = this.querySelector('[data-nw-soldout-note]');

      this.optionInputs = Array.from(this.querySelectorAll('[data-nw-option-input]'));
      this.optionInputs.forEach((el) => el.addEventListener('change', () => this.onOptionChange()));

      // Thumbnails
      const mainImg = document.querySelector('[data-nw-main-image]');
      document.querySelectorAll('[data-nw-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (mainImg) mainImg.src = btn.dataset.src;
          document.querySelectorAll('[data-nw-thumb]').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
      });

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    selectedOptions() {
      const out = [];
      this.optionInputs.forEach((el) => {
        if (el.checked) out.push(el.value);
      });
      return out;
    }

    matchVariant(values) {
      return (this.product.variants || []).find((v) =>
        v.options.every((opt, i) => opt === values[i])
      );
    }

    onOptionChange() {
      const values = this.selectedOptions();
      const variant = this.matchVariant(values);
      if (!variant) return;

      if (this.variantInput) this.variantInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = this.formatMoney(variant.price);
      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = this.formatMoney(variant.compare_at_price);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }
      if (this.stockLabel && this.stockDot) {
        if (variant.available) {
          this.stockLabel.textContent = 'In stock';
          this.stockDot.removeAttribute('data-empty');
          if (this.ctaLabel) this.ctaLabel.textContent = 'Add to basket';
          if (this.addBtn) this.addBtn.disabled = false;
        } else {
          this.stockLabel.textContent = 'Sold out';
          this.stockDot.setAttribute('data-empty', '');
          if (this.ctaLabel) this.ctaLabel.textContent = 'Sold out';
          if (this.addBtn) this.addBtn.disabled = true;
        }
      }
      if (this.soldoutNote) this.soldoutNote.hidden = variant.available;
      this.showVariantImage(variant);
    }

    showVariantImage(variant) {
      if (!variant.featured_image || !variant.featured_image.src) return;
      const mainImg = document.querySelector('[data-nw-main-image]');
      if (!mainImg) return;
      // Prefer activating the matching thumbnail so the active state stays in sync
      const filename = variant.featured_image.src.split('/').pop().split('?')[0];
      const thumbs = Array.from(document.querySelectorAll('[data-nw-thumb]'));
      const match = thumbs.find((b) => (b.dataset.src || '').includes(filename));
      if (match) {
        match.click();
        return;
      }
      mainImg.removeAttribute('srcset');
      mainImg.src = variant.featured_image.src;
      if (variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
    }

    formatMoney(cents) {
      // Cents → £XX.XX (GBP-only theme for v1, per docs/THEME_SPEC.md "Out of scope")
      const n = Number(cents) / 100;
      return '£' + n.toFixed(2);
    }

    async onSubmit(e) {
      e.preventDefault();
      const ctaBtn = this.addBtn || this.querySelector('[data-nw-add]');
      if (ctaBtn) ctaBtn.classList.add('is-loading');
      const data = new FormData(this.form);
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: data,
        });
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (this.ctaLabel) {
          const original = this.ctaLabel.textContent;
          this.ctaLabel.textContent = 'Added';
          setTimeout(() => { if (this.ctaLabel) this.ctaLabel.textContent = original; }, 1500);
        }
      } catch (err) {
        // Fallback: hard submit
        this.form.submit();
      } finally {
        if (ctaBtn) ctaBtn.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('nw-product-form')) {
    customElements.define('nw-product-form', NWProductForm);
  }
})();
